import Box, { type BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import type { DroppableProps as RBDDroppableProps } from 'react-beautiful-dnd';

export const DroppableArea = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'gap',
})<BoxProps & { direction: RBDDroppableProps['direction'] }>(({ theme, direction, gap }) => {
  const isGapValid = typeof gap === 'number';
  return direction === 'vertical'
    ? {
        flexDirection: 'column',
        '& > .Draggable-outlined': {
          marginBlockEnd: theme.spacing(isGapValid ? gap : 2),
        },
        '&:has(.Draggable-outlined)': {
          marginBlockEnd: `-${theme.spacing(isGapValid ? gap : 2)}`,
        },
        '& > .Draggable-flat': {
          marginBlockEnd: theme.spacing(isGapValid ? gap : 0),
        },
        '&:has(.Draggable-flat)': {
          marginBlockEnd: `-${theme.spacing(isGapValid ? gap : 0)}`,
        },
      }
    : {
        flexDirection: 'row',
        '& > .Draggable-outlined': {
          marginInlineEnd: theme.spacing(isGapValid ? gap : 2),
        },
        '&:has(.Draggable-outlined)': {
          marginInlineEnd: `-${theme.spacing(isGapValid ? gap : 2)}`,
        },
        '& > .Draggable-flat': {
          marginInlineEnd: theme.spacing(isGapValid ? gap : 0),
        },
        '&:has(.Draggable-flat)': {
          marginInlineEnd: `-${theme.spacing(isGapValid ? gap : 0)}`,
        },
      };
});
